import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import './admin-panel.css';

export default function AdminLayout() {
  const { logout } = useAdmin();
  const navigate = useNavigate();
  const routerLocation = useLocation();

  const [reviewCount, setReviewCount] = useState(0);
  const [publishedCount, setPublishedCount] = useState(0);
  const [blogReviewCount, setBlogReviewCount] = useState(0);
  const [blogPublishedCount, setBlogPublishedCount] = useState(0);
  const [vaccinationPendingCount, setVaccinationPendingCount] = useState(0);

  useEffect(() => {
    axios
      .get('/api/packages/', { params: { status: 'all' } })
      .then((response) => {
        const packages = response.data?.packages ?? [];
        setReviewCount(packages.filter((p) => p.status === 'review').length);
        setPublishedCount(packages.filter((p) => p.status === 'published').length);
      })
      .catch(() => {});

    axios
      .get('/api/blogs/', { params: { status: 'all' } })
      .then((response) => {
        const blogs = response.data?.blogs ?? [];
        setBlogReviewCount(blogs.filter((b) => b.status === 'review').length);
        setBlogPublishedCount(blogs.filter((b) => b.status === 'published').length);
      })
      .catch(() => {});

    axios
      .get('/api/vaccination-applications/', { params: { status: 'submitted' } })
      .then((response) => {
        const applications = response.data?.applications ?? [];
        setVaccinationPendingCount(applications.length);
      })
      .catch(() => {});
  }, [routerLocation.pathname]);

  const handleLogout = () => {
    logout();
    navigate('/adminpanel/login', { replace: true });
  };

  return (
    <div className="admin-root admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <div className="admin-brand-mark">
            <i className="fa fa-plane" />
          </div>
          <div className="admin-brand-text">
            <strong>Falcon Destinations</strong>
            <span>Admin Panel</span>
          </div>
        </div>

        <nav className="admin-nav">
          <NavLink
            to="/adminpanel/create"
            className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
          >
            <span className="admin-nav-step">1</span>
            Create Package
          </NavLink>
          <NavLink
            to="/adminpanel/review"
            className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
          >
            <span className="admin-nav-step">2</span>
            Review
            {reviewCount > 0 && <span className="badge-count">{reviewCount}</span>}
          </NavLink>
          <NavLink
            to="/adminpanel/publish"
            className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
          >
            <span className="admin-nav-step">3</span>
            Published
            {publishedCount > 0 && <span className="badge-count">{publishedCount}</span>}
          </NavLink>
        </nav>

        <div className="admin-nav-section-title">Blogs</div>
        <nav className="admin-nav">
          <NavLink
            to="/adminpanel/blogs/create"
            className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
          >
            <span className="admin-nav-step">1</span>
            Create Blog
          </NavLink>
          <NavLink
            to="/adminpanel/blogs/review"
            className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
          >
            <span className="admin-nav-step">2</span>
            Review
            {blogReviewCount > 0 && <span className="badge-count">{blogReviewCount}</span>}
          </NavLink>
          <NavLink
            to="/adminpanel/blogs/publish"
            className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
          >
            <span className="admin-nav-step">3</span>
            Published
            {blogPublishedCount > 0 && <span className="badge-count">{blogPublishedCount}</span>}
          </NavLink>
        </nav>

        <div className="admin-nav-section-title">Visa Vaccination</div>
        <nav className="admin-nav">
          <NavLink
            to="/adminpanel/vaccination-applications"
            className={({ isActive }) => `admin-nav-link${isActive ? ' active' : ''}`}
          >
            <span className="admin-nav-step"><i className="fa fa-syringe" /></span>
            Applications
            {vaccinationPendingCount > 0 && <span className="badge-count">{vaccinationPendingCount}</span>}
          </NavLink>
        </nav>

        <div className="admin-sidebar-footer">
          <button className="admin-logout-btn" onClick={handleLogout}>
            <i className="fa fa-sign-out-alt" />
            Log Out
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
